<template>
  <div class="flow-swap-button" @click.stop="$emit('click')">
    <i class="far fa-arrow-right-arrow-left" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FlowSwapButton",
  emits: ["click"]
});
</script>

<style lang="scss" scoped>
.flow-swap-button {
  position: absolute;
  transform: translate(-50%, -50%) rotate(45deg);
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: white;
  border: 1px solid #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 20; /* Above lines, below nodes */
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  color: #6b7280;

  &:hover {
    border-color: #9ca3af;
    transform: translate(-50%, -50%) rotate(45deg) scale(1.1);
    color: #374151;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  i {
    font-size: 0.875rem;
    transform: rotate(-45deg);
  }
}
</style>
